import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import constant from '@/utils/constant'
const baseURL = ''; // process.env.NODE_ENV === 'development' ? process.env.BASE_API : process.prod.BASE_API
// create an axios instance
const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      // console(config.params)
      config.params = {
        ...config.params,
        t: Date.parse(new Date()) / 1000
      }
    }
    // Do something before request is sent
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改 
      config.headers['authorization'] = store.getters.token
    }
    console.log(config);
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.error !== undefined && res.error !== 0) { 
      switch (res.error) {
        case constant.ERROR_TOKEN:
        case constant.ERROR_NOT_LOGGED:
          MessageBox.confirm('账号尚未登录成功或者超时', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
          return Promise.reject(new Error('账号尚未登录成功或者超时'))
        case constant.ERROR_PRODUCT_AUTH:
          MessageBox.alert('无权访问当前产品信息');
          return Promise.reject(new Error('无权访问当前产品信息'))
        case constant.ERROR_SAFE_LIMIT_ERROR:
          MessageBox.confirm('超过安全限制，需要重新登陆后操作', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
          return Promise.reject(new Error('超过安全限制，需要重新登陆后操作'))
        default:
          Message({
            message: res.errmsg,
            type: 'error',
            duration: 5 * 1000
          })
          return Promise.reject(new Error())
      }
    } else {
      return response
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/http.js